export default app => {
  app.config([configFn]);

  function configFn() {

  }
}



/** WEBPACK FOOTER **
 ** ./app.config.js
 **/